import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MarkdownModule } from "ngx-markdown";

// EZ
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { InputConfig, PanelHeaderConfig } from "@template-ui/types";
import { DocMeta } from "@template-ui/decorators";

// BITS
import { AppBaseComponent } from "../../../components/app-base.component";
import { SHOWCASE_LIBRARY_NAMES } from "../../showcase-library.constants";

@Component({
  selector: 'app-ez-grid-custom-paginator-sample',
  imports: [
    CommonModule, FormsModule,
    UiLibraryModule,
    MarkdownModule
],
  templateUrl: './ez-grid-custom-paginator-sample.component.html',
  styleUrl: './ez-grid-custom-paginator-sample.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@DocMeta({
  hide: true,
  showcaseAttachTo: [{ libName: SHOWCASE_LIBRARY_NAMES.BASE, classNames: ["EzGridComponent"] }],
  showcaseTitle:"EZ Paginator",
})
export class EzGridCustomPaginatorSampleComponent extends AppBaseComponent {

  useCustomPaginator: boolean = false;


  agPanelHeaderConfig: PanelHeaderConfig = {
    panelHeaderTitle: 'AG-Grid paginator (old and busted)',
    titleClickToReload: true,
  };

  ezPanelHeaderConfig = {
    panelHeaderTitle: 'EZ paginator (new hotness)',
    titleClickToReload: true,
    additionalActions: [
      {
        name: "blankRows",
        label:"Show blank rows on last page",
        type: "checkbox",

      } as InputConfig,
    ],
  };

  clientAgPanelHeaderConfig = {
    panelHeaderTitle: 'Client side paging - AG Grid paginator',
    titleClickToReload: true,
  };

  clientEzPanelHeaderConfig = {
    panelHeaderTitle: 'Client side paging - EZ Paginator',
    titleClickToReload: true,
  };

  clientAddActionsFormVals: Record<string, unknown> = {
    agPaginator: false,
    ezPaginator: false
  }

  ezAdditionActionFormValues: { blankRows: boolean } = {
    blankRows: false
  };

  additionalActionsFormValues: Record<string, unknown> = {
    agPaginator: true,
    ezPaginator: true
  };
}
